import { useAuth } from '@platform/auth-client';
import type { ReactNode } from 'react';
import { SessionExpiredPage } from '../pages/SessionExpiredPage.tsx';
import { SessionProgress } from '../pages/SessionProgress.tsx';

export const SessionGate = ({ children }: { children: ReactNode }) => {
  const auth = useAuth();
  if (auth.status === 'expired') return <SessionExpiredPage />;
  if (auth.status !== 'authenticated') return <SessionProgress stage="session" />;
  return children;
};
